module.exports = __webpack_public_path__ + "static/img/c60.88ade9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/c60.jpg
// module id = 5lMb
// module chunks = 0